import {Model} from "@vuex-orm/core";

export default class ProductRegion extends Model {
    static entity = 'productRegion'

    static primaryKey = ['product_id', 'region_id']

    static fields () {
        return {
            product_id: this.attr(null),
            region_id: this.attr(null)
        }
    }
}
